// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__srK5t","modalForm":"UpgradeEpcsModal_modalForm__1UeDt","modalFooter":"UpgradeEpcsModal_modalFooter__7xqoX"};